import React from "react";
import { ImageGalleryProps } from "../../types/interface";
import Uploads from "./Upload";
import Testing from "./Testing";
import { TestProvider, useTest } from "./TestContext";

const TestContent: React.FC<ImageGalleryProps> = ({ id }) => {
  const { filename, isUploading } = useTest();

  return (
    <div>
      {filename.name !== "" && !isUploading ? (
        <Testing id={id} />
      ) : (
        <Uploads id={id} />
      )}
    </div>
  );
};

const Test: React.FC<ImageGalleryProps> = ({ id }) => {
  return (
    <TestProvider>
      <TestContent id={id} />
    </TestProvider>
  );
};

export default Test;
